<template>
    <PublicProfileLayout>
    <div class="legal-center-wrapper p-4 md:p-6 surface-card border-round-xl shadow-1 text-left">
        <!-- Header Section -->
        <div class="mb-5 border-bottom-1 surface-border pb-4">
            <h1 class="H4-Bold text-primary mb-2">Legal Center</h1>
            <p class="text-700 font-light text-base max-w-xl">
                The Legal Center contains all policies, agreements, terms, and legal documents governing the use of the ILearn'd Tutors platform.
            </p>
        </div>

        <!-- Links Grid Grid -->
        <div class="grid g-3 md:g-4">
            
            <!-- Category: General Policies & Agreements -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
                <h3 class="H6-SemiBold text-900 mb-3 uppercase tracking-wider text-xs font-bold text-600">General Policies</h3>
                <div class="flex flex-column gap-3">
                    <router-link to="/termsOfService#user-agreement" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-file-pdf mr-2 text-primary-400"></i>User Agreement
                    </router-link>
                    <router-link to="/privacy-policy" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-shield mr-2 text-primary-400"></i>Privacy Policy
                    </router-link>
                    <router-link to="/privacy-policy#cookie-policy" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-info-circle mr-2 text-primary-400"></i>Cookie Policy
                    </router-link>
                </div>
            </div>

            <!-- Category: Role Specific Terms -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
                <h3 class="H6-SemiBold text-900 mb-3 uppercase tracking-wider text-xs font-bold text-600">User Terms</h3>
                <div class="flex flex-column gap-3">
                    <router-link to="/termsOfService#student-terms" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-user mr-2 text-primary-400"></i>Terms & Conditions for Students
                    </router-link>
                    <router-link to="/termsOfService#tutor-terms" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-briefcase mr-2 text-primary-400"></i>Terms & Conditions for Tutors
                    </router-link>
                    <router-link to="/" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-building mr-2 text-primary-400"></i>Institute Partnership Agreement
                    </router-link>
                </div>
            </div>

            <!-- Category: Financial & Payments -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
                <h3 class="H6-SemiBold text-900 mb-3 uppercase tracking-wider text-xs font-bold text-600">Payments & Finance</h3>
                <div class="flex flex-column gap-3">
                    <router-link to="/" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-credit-card mr-2 text-primary-400"></i>Payment Terms & Conditions
                    </router-link>
                    <router-link to="/privacy-policy#refund-policy" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-refresh mr-2 text-primary-400"></i>Refund Policy
                    </router-link>
                </div>
            </div>

            <!-- Category: Governance & Safety -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
                <h3 class="H6-SemiBold text-900 mb-3 uppercase tracking-wider text-xs font-bold text-600">Ethics & Protection</h3>
                <div class="flex flex-column gap-3">
                    <router-link to="/privacy-policy#child-protection" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-heart-fill mr-2 text-primary-400"></i>Child Protection & Safeguarding Policy
                    </router-link>
                    <router-link to="/privacy-policy#ai-governance" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-android mr-2 text-primary-400"></i>AI Usage, Ethics & Governance Policy
                    </router-link>
                </div>
            </div>

            <!-- Category: Support & Legal -->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
                <h3 class="H6-SemiBold text-900 mb-3 uppercase tracking-wider text-xs font-bold text-600">Complaints & Disclaimers</h3>
                <div class="flex flex-column gap-3">
                    <router-link to="/" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-exclamation-circle mr-2 text-primary-400"></i>Formal Complaints Procedure
                    </router-link>
                    <router-link to="/" class="legal-link text-body no-underline hover:text-primary transition-colors duration-200">
                        <i class="pi pi-ban mr-2 text-primary-400"></i>Legal Disclaimer
                    </router-link>
                </div>
            </div>

        </div>
    </div>
    </PublicProfileLayout>
</template>

<script setup>
import PublicProfileLayout from '@/layout/PublicProfileLayout.vue';

// You can handle any routing logic or analytic event clicks here if needed.
</script>

<style scoped>
.legal-link {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0;
    font-weight: 500;
}
.legal-link:hover {
    text-decoration: underline;
}
</style>